// https://stackoverflow.com/questions/66389974/using-font-awesome-in-vue-3
// https://fontawesome.com/
// 以下引用fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTimes,
  faAngleDoubleRight,
  faUserSlash,
  faChevronRight,
  faPhotoVideo,
  faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/scss/app.scss';
// globla components

import * as globalComponents from './components/index';

const app = createApp(App);

library.add(faTimes);
library.add(faAngleDoubleRight);
library.add(faUserSlash);
library.add(faChevronRight);
library.add(faPhotoVideo);
library.add(faPaperPlane);

app.component('FontAwesomeIcon', FontAwesomeIcon);

// 引入global components
Object.entries(globalComponents).forEach(([key, value]) => {
  app.component(key, value);
});

app.use(router).mount('#app');
